import sha512 from "crypto-js/sha512";
import moment from "moment";
export const xCheckSumIdGernator = (username) => {
  const generator = Math.floor(Math.random() * 100000000);
  const allValues = `${username}${generator}54IzSRi`;
  const allValuesHashed = sha512(allValues).toString();
  return { allValuesHashed, generator };
};

export const dateFormatter = (date) => {
  return moment(date).format("lll");
};
